import { CurrencyIcon } from "@/helpers/currencyIcon"
import { ROUTES } from "@/helpers/routes"
import { STORE_CURRENCY } from "@/store/apis/storePaymentsAPI"

export const ShopCurrencies = [
  {
    currency: STORE_CURRENCY.EXTERNAL_TON,
    icon: CurrencyIcon.ton
  },
  {
    currency: STORE_CURRENCY.TG_STARS,
    icon: CurrencyIcon.star
  }
] as const

export enum SHOP_TABS {
  SKINS = "skins",
  GOLD_CARD = "gold-card"
}

export interface IShopTab {
  key: SHOP_TABS
  label: string
  path: string
}

export const SHOP_TABS_CONFIG: IShopTab[] = [
  { key: SHOP_TABS.SKINS, label: "shop.tabs.skins", path: ROUTES.SHOP_SKINS },
  {
    key: SHOP_TABS.GOLD_CARD,
    label: "shop.tabs.goldCards",
    path: ROUTES.SHOP_GOLD_CARD
  }
]
